<template>
  <div class="filter">
    <div class="items" v-for="(f, fi) in filters" :key="fi">
      <div class="item">
        <div class="left">
          <span class="title">
            {{f.title}}
          </span>
          <p :class="{selectors: true, overflow: f.expand}" :ref="`items${fi}`">
            <span :class="{active: i.selected, selector: true}" v-for="(i, d) in f.list" :key="d" @click="selectStatus(f, i)">
              {{i.title}}
            </span>
          </p>
          <div class="expander" @click="changeExpand(f, `items${fi}`)" :ref="`expander${fi}`" v-show="checkEleHeight(`items${fi}`, `expander${fi}`)">
            <img :src="f.expand ? icons.upward : icons.downward" alt="icon">
          </div>
        </div>
      </div>
      <div class="item" v-for="(c, ci) in f.list" :key="ci" v-show="c.list && c.list.length > 0 && c.selected">
        <div class="left">
          <span class="title">
            {{c.title}}
          </span>
          <p :class="{selectors: true, overflow: c.expand}" :ref="`${c.key}${ci}`">
            <span :class="{active: q.selected, selector: true}" v-for="(q, qi) in c.list" :key="qi" @click="selectStatus(c, q)">
              {{q.title}}
            </span>
          </p>
          <div class="expander" @click="changeExpand(c, `${c.key}${ci}`)" :ref="`e${c.key}${ci}`" v-show="checkEleHeight(`${c.key}${ci}`, `e${c.key}${ci}`)">
            <img :src="c.expand ? icons.upward : icons.downward" alt="icon">
          </div>
        </div>
      </div>
    </div>
    <div class="item noBottom">
      <div class="item noBottom">
        <span class="timeTitle">
          {{date.title}}
        </span>
        <date-picker :type="date.type" :format="'YYYY-MM-DD'" v-model="datePicker" :range="date.range" :placeholder="date.placer" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import common from '@common/common'
export default {
  name: 'evaluationFilter',
  components: {
    DatePicker
  },
  props: {
    type: String,
    date: Object,
    filters: Array
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n) {
        const unique = !this.date.range
        let s = unique ? n : (n ? n[0] : '')
        let e = unique ? n : (n ? n[1] : '')
        this.start = s ? this.getDayStart(s) : ''
        this.end = e ? this.getDayEnd(e) : ''

        this.emitData()
      }
    }
  },
  data() {
    return {
      datePicker: '',
      start: '',
      end: '',
      icons: {
        downward: require('@assets/img/common/xiala.svg'),
        upward: require('@assets/img/common/upward.svg')
      }
    }
  },
  methods: {
    emitData() {
      // 向外传递组件数据
      const data = {}
      const isUnique = this.type === 'unique'
      this.filters.forEach((i) => {
        i.list && i.list.forEach((l) => {
          if (l.selected) {
            if (!l.list || l.list.length === 0)  {
              if (isUnique) {
                data[i.key] = l.key
              } else {
                data[i.key] = (data[i.key] ? `${data[i.key]},` : '') + l.key
              }
            } else {
              const keyArr = []
              keyArr.push(l.key)

              l.list.forEach(c => {
                if (c.selected) {
                  keyArr.push(c.key)
                }
              })
              
              if (isUnique) {
                data[i.key] = keyArr.join(',')
              } else {
                data[i.key] = (data[i.key] ? `${data[i.key]},` : '') + keyArr.join(',')
              }
            }
          }
        })
      })
      data['start'] = this.start
      data['end'] = this.end

      this.$emit('getFilters', data)
    },
    checkEleHeight(items, expander) {
      // 为实现页面加载后检测是否有换行出现，只能操作dom。里面夹带了具体样式数值
      setTimeout(() => {
        let overflow = false
        const height = this.$refs[items][0].getBoundingClientRect().height

        if (height > 42) {
          overflow = true
        }

        if (overflow) {
          this.$refs[items][0].style.height = '42px'
          this.$refs[expander][0].style.display = 'flex'
        }

        return overflow
      }, 0)
    },
    changeExpand(c, key) {
      // 切换类目展开／收起
      this.$set(c, 'expand', !c.expand)

      this.$nextTick(() => {
        if (!c.expand) {
          // 关闭的项目自动回到顶部
          this.$refs[key][0].scrollTop = 0
        }
      })
    },
    selectStatus(f, i) {
      // 选择过滤条件
      if (this.type === 'unique') {
        f.list.forEach((l) => {
          l.selected = false
        })

        this.$set(i, 'selected', true)
      } else {
        this.$set(i, 'selected', !i.selected)
      }

      this.$nextTick(() => {
        this.emitData()
      })
    },
    getDayStart(t) {
      // 获取一天开始时间
      if (!t) {
        return ''
      }

      const year = t.getFullYear()
      const month = common.doubleDigit(t.getMonth() + 1)
      const day = common.doubleDigit(t.getDate())

      return  `${year}-${month}-${day} 00:00:00`
    },
    getDayEnd(t) {
      // 获取一天开始时间
      if (!t) {
        return ''
      }

      const year = t.getFullYear()
      const month = common.doubleDigit(t.getMonth() + 1)
      const day = common.doubleDigit(t.getDate())

      return  `${year}-${month}-${day} 23:59:59`
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .filter {
    padding: 20px 30px;
    .mb20 {
      margin-bottom: 20px;
    }
    .items:last-child {
      .item:last-child {
        margin: 0;
      }
    }
    .noBottom {
      margin-bottom: 0 !important;
    }
    .item {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 20px;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: flex-start;
      }
      .title {
        color: @green;
        font-weight: bold;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        width: 52px;
        text-align-last: justify;
        -webkit-align-last: justify;
        -moz-text-align-last: justify;
        -ms-text-align-last: justify;
        margin: 0 30px 10px 0;
        flex-shrink: 0;
      }
      .timeTitle {
        color: @green;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        font-weight: bold;
        width: 52px;
        text-align-last: justify;
        -webkit-align-last: justify;
        -moz-text-align-last: justify;
        -ms-text-align-last: justify;
        margin: 0 30px 0 0;
        flex-shrink: 0;
      }
      .datePicker {
        display: flex;
        align-items: center;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        height: 28px;
        padding: 0 10px;
        color: @dateColor;
        span {
          margin: 0 40px;
          cursor: default;
        }
      }
      .selectors {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        height: auto;
        max-height: 90px;
        overflow: hidden;
        .selector {
          padding: 0 4px;
          min-width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 100px;
          border: 1px solid transparent;
          color: @sub;
          cursor: pointer;
          margin: 0 0 10px 4px;
        }
        .selector:first-child {
          margin: 0 0 10px 0;
        }
      }
      .overflow {
        flex-wrap: wrap;
        height: auto !important;
        overflow-y: auto;
      }
      .expander {
        width: 30px;
        height: 30px;
        border: 1px solid @dc;
        border-radius: 2px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .active {
        border-color: @green !important;
        color: @green !important;
      }
      .createBtn {
        width: 120px;
        height: 40px;
        border-radius: 100px;
        background-color: @green;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          margin-right: 10px;
        }
        &:active {
          .btnActive;
        }
        &:hover {
          .btnHover;
        }
      }
    }
  }
</style>